
function Drinks () {
    return (
        <img className="menuImage" src="/images/Drinks.jpg" alt=""/>
    )
}


export default Drinks;
